import { Component, OnInit } from '@angular/core';
import { ArbitrosModule } from './arbitros.module';
import { Arbitro } from './arbitros.model';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import * as XLSX from 'xlsx';
import { getCurrentLanguage } from '../core/helpers/utils';
import { arbitroTranslations } from './translations-arbitro';
import { generalTranslations } from '../core/helpers/translations';

// services
import { EventService } from 'src/app/core/service/event.service';
import { ArbitrosService } from './arbitros.service';


// constants
import { EventType } from 'src/app/core/constants/events';
import { FormBuilder, FormGroup, NgForm } from '@angular/forms';

// Para el selector de países múltiple
import { Select2Data } from 'ng-select2-component';
import { Column } from '../shared/advanced-table/advanced-table.component';
import { SortEvent } from '../shared/advanced-table/sortable.directive';

import { convertNacionalidadesToLabels, convertIdiomasToLabels } from '../core/helpers/utils';

@Component({
  selector: 'app-buscador-arbitros',
  templateUrl: './buscador-arbitros.component.html',
  styleUrls: ['./buscador-arbitros.component.scss']
})


export class BuscadorArbitrosComponent implements OnInit {



  constructor(
    private eventService: EventService,
    private arbitrosService: ArbitrosService,
    private router: Router,
    private fb: FormBuilder,) { }

  // Tabla
  records: Arbitro[] = [];
  columns: Column[] = [];
  pageSizeOptions: number[] = [10, 25, 50, 100];
  // Para controlar las búsquedas
  allDatasearch: Arbitro[] = []

  // Botón de acción de la tabla, en blanco porque no tenemos acción
  buttonTitle: string = '';
  buttonLink: string = '';

  nacionalidades: Select2Data = [];
  sectores: Select2Data = [];
  sistemasJuridicos: Select2Data = [];
  experienciaOpciones: Select2Data = [];
  idiomas: Select2Data = [];
  profesiones: Select2Data = [];
  colegiaciones: Select2Data = [];
  basicWizardForm!: FormGroup;

  loaded: boolean = false;
  filtrando: boolean = false;
  submitted: boolean = false;

  // Control de errores
  error: string = '';

  // Control de Accordions abiertos
  public openIds: string[] = [];

  model = {
    nivel_acceso: 'ADMIN',
    nacionalidades: [],
    sectores: [],
    sistemasJuridicos: [],
    exp_internacional_ciam_presidente: "",
    exp_internacional_otra_presidente: "",
    exp_internacional_adhoc_presidente: "",
    exp_nacional_institucional_presidente: "",
    exp_nacional_adhoc_presidente: "",
    exp_internacional_ciam_arbitro_unico: "",
    exp_internacional_otra_arbitro_unico: "",
    exp_internacional_adhoc_arbitro_unico: "",
    exp_nacional_institucional_arbitro_unico: "",
    exp_nacional_adhoc_arbitro_unico: "",
    exp_internacional_ciam_coarbitro: "",
    exp_internacional_otra_coarbitro: "",
    exp_internacional_adhoc_coarbitro: "",
    exp_nacional_institucional_coarbitro: "",
    exp_nacional_adhoc_coarbitro: "",
    exp_internacional_ciam_letrado: "",
    exp_internacional_otra_letrado: "",
    exp_internacional_adhoc_letrado: "",
    exp_nacional_institucional_letrado: "",
    exp_nacional_adhoc_letrado: "",
    exp_internacional_ciam_secretario: "",
    exp_internacional_otra_secretario: "",
    exp_internacional_adhoc_secretario: "",
    exp_nacional_institucional_secretario: "",
    exp_nacional_adhoc_secretario: "",
    exp_internacional_ciam_arbitro_emergencia: "",
    exp_internacional_otra_arbitro_emergencia: "",
    exp_internacional_adhoc_arbitro_emergencia: "",
    exp_nacional_institucional_arbitro_emergencia: "",
    exp_nacional_adhoc_arbitro_emergencia: "",
    invertirNacionalidades: false,
    soloCompletados: false
  }

  trackByFunc(index: number, item: any): any {
    return item.id; // o cualquier propiedad única de tus objetos
  }

  ngOnInit(): void {
    let currentLanguage: string = getCurrentLanguage()
    const currentTranslations = generalTranslations[currentLanguage].TABLE;
    this.eventService.broadcast(EventType.CHANGE_PAGE_TITLE,
      {
        title: currentTranslations.BUSCADOR,
        breadCrumbItems: [{ label: currentTranslations.ARBITROS, path: '.' }, { label: currentTranslations.BUSCADOR, path: '.', active: true }]
      }
    );

    this.initializeForm();

    // Marco es_arbitro automáticamente si se marca Sólo árbitros con experiencia
    this.basicWizardForm.get('datos.soloCompletados')?.valueChanges.subscribe((soloCompletados: boolean) => {
      if (soloCompletados) {
        // Si se marca "soloCompletados", marca "es_arbitro"
        this.basicWizardForm.get('datos.es_arbitro')?.setValue(true, { emitEvent: false });
      }
    });

    forkJoin({
      resNacionalidades: this.arbitrosService.getNacionalidades(),
      resArbitros: this.arbitrosService.getArbitros(),
      resSectores: this.arbitrosService.getSectores(),
      resSistemasJuridicos: this.arbitrosService.getSistemasJuridicos(),
      resIdiomas: this.arbitrosService.getIdiomas(),
      resProfesiones: this.arbitrosService.getProfesiones(),
      resColegiaciones: this.arbitrosService.getColegiaciones()
    }).subscribe({
      next: ({ resNacionalidades, resArbitros, resSectores, resSistemasJuridicos, resIdiomas, resProfesiones, resColegiaciones }) => {
        //console.log("Arbitro-> ", resArbitro);

        // Procesamiento de los arbitros
        this.records = resArbitros.filter(arbitro => arbitro.es_arbitro === true);
        this.allDatasearch = this.records; // Guardo una copia de todos los datos para la búsqueda
        this.initTableCofig()

        // Procesamiento datos para Nacionalidades
        const dataNacionalidadesFromDB = resNacionalidades;
        const convertedNacionalidadesData = dataNacionalidadesFromDB.map(item => ({
          value: item.codigo_alfa2,
          label: item.es
        }));
        this.nacionalidades = convertedNacionalidadesData;

        // Procesamiento datos para sectores
        const dataSectoresFromDB = resSectores;
        const convertedSectoresData = dataSectoresFromDB.map(item => ({
          value: item.nombre,
          label: item.es // Asumiendo que el campo se llama 'nombre'
        }));
        this.sectores = convertedSectoresData;

        // Procesamiento datos para sistemasJuridicos
        const dataSistemasJuridicosFromDB = resSistemasJuridicos;
        const convertedSistemasJuridicosData = dataSistemasJuridicosFromDB.map(item => ({
          value: item.nombre,
          label: item.es // Asumiendo que el campo se llama 'nombre'
        }));
        this.sistemasJuridicos = convertedSistemasJuridicosData;

        // Procesamiento datos para Idiomas
        const dataIdiomasFromDB = resIdiomas;
        const convertedIdiomasData = dataIdiomasFromDB.map(item => ({
          value: item.nombre,
          label: item.es
        }));
        this.idiomas = convertedIdiomasData;

        // Procesamiento datos para Profesiones
        const dataProfesionesFromDB = resProfesiones;
        const convertedProfesionesData = dataProfesionesFromDB.map(item => ({
          value: item.nombre,
          label: item.es
        }));
        this.profesiones = convertedProfesionesData;

        // Procesamiento datos para Colegiaciones
        const dataColegiacionesFromDB = resColegiaciones;
        const convertedColegiacionesData = dataColegiacionesFromDB.map(item => ({
          value: item.codigo_alfa2,
          label: item.es
        }));
        this.colegiaciones = convertedColegiacionesData;

        // Valores del campo de experiencia
        this.experienciaOpciones = [
          { label: "N/A", value: 0 },
          { label: "De 1 a 10", value: 1 },
          { label: "De 11 a 25", value: 2 },
          { label: "Más de 25", value: 3 }
        ]

        this.loaded = true;
      },
      error: (error) => {
        //this.error = error;
        //this.loaded = false;
      }
    });

  }


  onSubmit() {

    // Obtener los valores del formulario
    const formData = this.basicWizardForm.value;

    const arbitro: Arbitro = {
      sectores: formData.datos.sectores,
      nacionalidades: formData.datos.nacionalidades,
      sistemasJuridicos: formData.datos.sistemasJuridicos,
      exp_internacional_ciam_presidente: formData.datos.exp_internacional_ciam_presidente,
      exp_internacional_otra_presidente: formData.datos.exp_internacional_otra_presidente,
      exp_internacional_adhoc_presidente: formData.datos.exp_internacional_adhoc_presidente,
      exp_nacional_institucional_presidente: formData.datos.exp_nacional_institucional_presidente,
      exp_nacional_adhoc_presidente: formData.datos.exp_nacional_adhoc_presidente,
      exp_internacional_ciam_arbitro_unico: formData.datos.exp_internacional_ciam_arbitro_unico,
      exp_internacional_otra_arbitro_unico: formData.datos.exp_internacional_otra_arbitro_unico,
      exp_internacional_adhoc_arbitro_unico: formData.datos.exp_internacional_adhoc_arbitro_unico,
      exp_nacional_institucional_arbitro_unico: formData.datos.exp_nacional_institucional_arbitro_unico,
      exp_nacional_adhoc_arbitro_unico: formData.datos.exp_nacional_adhoc_arbitro_unico,
      exp_internacional_ciam_coarbitro: formData.datos.exp_internacional_ciam_coarbitro,
      exp_internacional_otra_coarbitro: formData.datos.exp_internacional_otra_coarbitro,
      exp_internacional_adhoc_coarbitro: formData.datos.exp_internacional_adhoc_coarbitro,
      exp_nacional_institucional_coarbitro: formData.datos.exp_nacional_institucional_coarbitro,
      exp_nacional_adhoc_coarbitro: formData.datos.exp_nacional_adhoc_coarbitro,
      exp_internacional_ciam_letrado: formData.datos.exp_internacional_ciam_letrado,
      exp_internacional_otra_letrado: formData.datos.exp_internacional_otra_letrado,
      exp_internacional_adhoc_letrado: formData.datos.exp_internacional_adhoc_letrado,
      exp_nacional_institucional_letrado: formData.datos.exp_nacional_institucional_letrado,
      exp_nacional_adhoc_letrado: formData.datos.exp_nacional_adhoc_letrado,
      exp_internacional_ciam_secretario: formData.datos.exp_internacional_ciam_secretario,
      exp_internacional_otra_secretario: formData.datos.exp_internacional_otra_secretario,
      exp_internacional_adhoc_secretario: formData.datos.exp_internacional_adhoc_secretario,
      exp_nacional_institucional_secretario: formData.datos.exp_nacional_institucional_secretario,
      exp_nacional_adhoc_secretario: formData.datos.exp_nacional_adhoc_secretario,
      exp_internacional_ciam_arbitro_emergencia: formData.datos.exp_internacional_ciam_arbitro_emergencia,
      exp_internacional_otra_arbitro_emergencia: formData.datos.exp_internacional_otra_arbitro_emergencia,
      exp_internacional_adhoc_arbitro_emergencia: formData.datos.exp_internacional_adhoc_arbitro_emergencia,
      exp_nacional_institucional_arbitro_emergencia: formData.datos.exp_nacional_institucional_arbitro_emergencia,
      exp_nacional_adhoc_arbitro_emergencia: formData.datos.exp_nacional_adhoc_arbitro_emergencia,
      invertirNacionalidades: formData.datos.invertirNacionalidades,
      soloCompletados: formData.datos.soloCompletados,
      es_arbitro: formData.datos.es_arbitro,
      es_representante: formData.datos.es_representante
    }

    // Marco los accordions que deben permanecer abiertos
    this.updateOpenPanels();

    this.reloadData(arbitro);

    //console.log("Búsqueda enviada ->", arbitro)

    /*
    this.arbitrosService.newUsuario(usuario)
      .subscribe(res => {
        this.router.navigate(['/usuarios']);
      })
      */

  }

  reloadData(datosFiltro: Arbitro) {
    this.filtrando = true;
    this.submitted = true;

    let filtroSectores = datosFiltro.sectores ?? [];
    let filtroNacionalidades = datosFiltro.nacionalidades ?? [];
    let filtroSistemasJuridicos = datosFiltro.sistemasJuridicos ?? [];
    let invertirNacionalidades = datosFiltro.invertirNacionalidades;
    let soloCompletados = datosFiltro.soloCompletados;
    let es_arbitro = datosFiltro.es_arbitro;
    let es_representante = datosFiltro.es_representante;
    // Preparar los datos de filtro convertidos a números.
    let filtro_exp_internacional_ciam_presidente = Number(datosFiltro.exp_internacional_ciam_presidente) || 0;
    let filtro_exp_internacional_otra_presidente = Number(datosFiltro.exp_internacional_otra_presidente) || 0;
    let filtro_exp_internacional_adhoc_presidente = Number(datosFiltro.exp_internacional_adhoc_presidente) || 0;
    let filtro_exp_nacional_institucional_presidente = Number(datosFiltro.exp_nacional_institucional_presidente) || 0;
    let filtro_exp_nacional_adhoc_presidente = Number(datosFiltro.exp_nacional_adhoc_presidente) || 0;
    let filtro_exp_internacional_ciam_arbitro_unico = Number(datosFiltro.exp_internacional_ciam_arbitro_unico) || 0;
    let filtro_exp_internacional_otra_arbitro_unico = Number(datosFiltro.exp_internacional_otra_arbitro_unico) || 0;
    let filtro_exp_internacional_adhoc_arbitro_unico = Number(datosFiltro.exp_internacional_adhoc_arbitro_unico) || 0;
    let filtro_exp_nacional_institucional_arbitro_unico = Number(datosFiltro.exp_nacional_institucional_arbitro_unico) || 0;
    let filtro_exp_nacional_adhoc_arbitro_unico = Number(datosFiltro.exp_nacional_adhoc_arbitro_unico) || 0;
    let filtro_exp_internacional_ciam_coarbitro = Number(datosFiltro.exp_internacional_ciam_coarbitro) || 0;
    let filtro_exp_internacional_otra_coarbitro = Number(datosFiltro.exp_internacional_otra_coarbitro) || 0;
    let filtro_exp_internacional_adhoc_coarbitro = Number(datosFiltro.exp_internacional_adhoc_coarbitro) || 0;
    let filtro_exp_nacional_institucional_coarbitro = Number(datosFiltro.exp_nacional_institucional_coarbitro) || 0;
    let filtro_exp_nacional_adhoc_coarbitro = Number(datosFiltro.exp_nacional_adhoc_coarbitro) || 0;
    let filtro_exp_internacional_ciam_letrado = Number(datosFiltro.exp_internacional_ciam_letrado) || 0;
    let filtro_exp_internacional_otra_letrado = Number(datosFiltro.exp_internacional_otra_letrado) || 0;
    let filtro_exp_internacional_adhoc_letrado = Number(datosFiltro.exp_internacional_adhoc_letrado) || 0;
    let filtro_exp_nacional_institucional_letrado = Number(datosFiltro.exp_nacional_institucional_letrado) || 0;
    let filtro_exp_nacional_adhoc_letrado = Number(datosFiltro.exp_nacional_adhoc_letrado) || 0;
    let filtro_exp_internacional_ciam_secretario = Number(datosFiltro.exp_internacional_ciam_secretario) || 0;
    let filtro_exp_internacional_otra_secretario = Number(datosFiltro.exp_internacional_otra_secretario) || 0;
    let filtro_exp_internacional_adhoc_secretario = Number(datosFiltro.exp_internacional_adhoc_secretario) || 0;
    let filtro_exp_nacional_institucional_secretario = Number(datosFiltro.exp_nacional_institucional_secretario) || 0;
    let filtro_exp_nacional_adhoc_secretario = Number(datosFiltro.exp_nacional_adhoc_secretario) || 0;
    let filtro_exp_internacional_ciam_arbitro_emergencia = Number(datosFiltro.exp_internacional_ciam_arbitro_emergencia) || 0;
    let filtro_exp_internacional_otra_arbitro_emergencia = Number(datosFiltro.exp_internacional_otra_arbitro_emergencia) || 0;
    let filtro_exp_internacional_adhoc_arbitro_emergencia = Number(datosFiltro.exp_internacional_adhoc_arbitro_emergencia) || 0;
    let filtro_exp_nacional_institucional_arbitro_emergencia = Number(datosFiltro.exp_nacional_institucional_arbitro_emergencia) || 0;
    let filtro_exp_nacional_adhoc_arbitro_emergencia = Number(datosFiltro.exp_nacional_adhoc_arbitro_emergencia) || 0;
    //let filtroejemploTexto = this.normalizeText(datosFiltro.ejemploTexto);


    this.arbitrosService.getArbitros().subscribe((res) => {
      this.records = res.filter(arbitro =>
        (
          (!es_arbitro && !es_representante && false) || // Ninguno está marcado, excluye todo
          (es_arbitro && !es_representante && arbitro.es_arbitro === true) || // Solo es_arbitro está marcado
          (!es_arbitro && es_representante && arbitro.es_representante === true) || // Solo es_representante está marcado
          (es_arbitro && es_representante && arbitro.es_arbitro === true && arbitro.es_representante === true) // Ambos están marcados
        ) &&
        //this.normalizeText(arbitro.ejemploTexto).includes(filtroejemploTexto) &&
        // Aplica el filtro de nacionalidades solo si filtroNacionalidades no está vacío, utilizando paréntesis para claridad
        (filtroSectores.length === 0 || (arbitro.sectores?.some(sectores => filtroSectores.includes(sectores)) ?? false)) &&
        //(filtroNacionalidades.length === 0 || (arbitro.nacionalidades?.some(nacionalidad => filtroNacionalidades.includes(nacionalidad)) ?? false)) &&
        (filtroNacionalidades.length === 0 ||
          (invertirNacionalidades
            ? !(arbitro.nacionalidades?.some(nacionalidad => filtroNacionalidades.includes(nacionalidad)) ?? false)
            : (arbitro.nacionalidades?.some(nacionalidad => filtroNacionalidades.includes(nacionalidad)) ?? false)
          )
        ) &&
        (!soloCompletados || arbitro.datos_obligatorios_completados === true) &&
        (filtroSistemasJuridicos.length === 0 || (arbitro.sistemasJuridicos?.some(sistemasJuridicos => filtroSistemasJuridicos.includes(sistemasJuridicos)) ?? false)) &&
        this.cumpleExperiencia(filtro_exp_internacional_ciam_presidente, Number(arbitro.exp_internacional_ciam_presidente)) &&
        this.cumpleExperiencia(filtro_exp_internacional_otra_presidente, Number(arbitro.exp_internacional_otra_presidente)) &&
        this.cumpleExperiencia(filtro_exp_internacional_adhoc_presidente, Number(arbitro.exp_internacional_adhoc_presidente)) &&
        this.cumpleExperiencia(filtro_exp_nacional_institucional_presidente, Number(arbitro.exp_nacional_institucional_presidente)) &&
        this.cumpleExperiencia(filtro_exp_nacional_adhoc_presidente, Number(arbitro.exp_nacional_adhoc_presidente)) &&
        this.cumpleExperiencia(filtro_exp_internacional_ciam_arbitro_unico, Number(arbitro.exp_internacional_ciam_arbitro_unico)) &&
        this.cumpleExperiencia(filtro_exp_internacional_otra_arbitro_unico, Number(arbitro.exp_internacional_otra_arbitro_unico)) &&
        this.cumpleExperiencia(filtro_exp_internacional_adhoc_arbitro_unico, Number(arbitro.exp_internacional_adhoc_arbitro_unico)) &&
        this.cumpleExperiencia(filtro_exp_nacional_institucional_arbitro_unico, Number(arbitro.exp_nacional_institucional_arbitro_unico)) &&
        this.cumpleExperiencia(filtro_exp_nacional_adhoc_arbitro_unico, Number(arbitro.exp_nacional_adhoc_arbitro_unico)) &&
        this.cumpleExperiencia(filtro_exp_internacional_ciam_coarbitro, Number(arbitro.exp_internacional_ciam_coarbitro)) &&
        this.cumpleExperiencia(filtro_exp_internacional_otra_coarbitro, Number(arbitro.exp_internacional_otra_coarbitro)) &&
        this.cumpleExperiencia(filtro_exp_internacional_adhoc_coarbitro, Number(arbitro.exp_internacional_adhoc_coarbitro)) &&
        this.cumpleExperiencia(filtro_exp_nacional_institucional_coarbitro, Number(arbitro.exp_nacional_institucional_coarbitro)) &&
        this.cumpleExperiencia(filtro_exp_nacional_adhoc_coarbitro, Number(arbitro.exp_nacional_adhoc_coarbitro)) &&
        this.cumpleExperiencia(filtro_exp_internacional_ciam_letrado, Number(arbitro.exp_internacional_ciam_letrado)) &&
        this.cumpleExperiencia(filtro_exp_internacional_otra_letrado, Number(arbitro.exp_internacional_otra_letrado)) &&
        this.cumpleExperiencia(filtro_exp_internacional_adhoc_letrado, Number(arbitro.exp_internacional_adhoc_letrado)) &&
        this.cumpleExperiencia(filtro_exp_nacional_institucional_letrado, Number(arbitro.exp_nacional_institucional_letrado)) &&
        this.cumpleExperiencia(filtro_exp_nacional_adhoc_letrado, Number(arbitro.exp_nacional_adhoc_letrado)) &&
        this.cumpleExperiencia(filtro_exp_internacional_ciam_secretario, Number(arbitro.exp_internacional_ciam_secretario)) &&
        this.cumpleExperiencia(filtro_exp_internacional_otra_secretario, Number(arbitro.exp_internacional_otra_secretario)) &&
        this.cumpleExperiencia(filtro_exp_internacional_adhoc_secretario, Number(arbitro.exp_internacional_adhoc_secretario)) &&
        this.cumpleExperiencia(filtro_exp_nacional_institucional_secretario, Number(arbitro.exp_nacional_institucional_secretario)) &&
        this.cumpleExperiencia(filtro_exp_nacional_adhoc_secretario, Number(arbitro.exp_nacional_adhoc_secretario)) &&
        this.cumpleExperiencia(filtro_exp_internacional_ciam_arbitro_emergencia, Number(arbitro.exp_internacional_ciam_arbitro_emergencia)) &&
        this.cumpleExperiencia(filtro_exp_internacional_otra_arbitro_emergencia, Number(arbitro.exp_internacional_otra_arbitro_emergencia)) &&
        this.cumpleExperiencia(filtro_exp_internacional_adhoc_arbitro_emergencia, Number(arbitro.exp_internacional_adhoc_arbitro_emergencia)) &&
        this.cumpleExperiencia(filtro_exp_nacional_institucional_arbitro_emergencia, Number(arbitro.exp_nacional_institucional_arbitro_emergencia)) &&
        this.cumpleExperiencia(filtro_exp_nacional_adhoc_arbitro_emergencia, Number(arbitro.exp_nacional_adhoc_arbitro_emergencia)) && true
      );

      this.allDatasearch = this.records; // Guarda una copia de todos los datos filtrados para usar dentro de la búsqueda
      //console.log("Results-> ",this.allDatasearch)
      this.filtrando = false;
    },
      (error: string) => {
        this.error = error;
        this.loaded = false;
      });
  }

  private cumpleExperiencia(valorFiltro: number, experienciaArbitro: number): boolean {
    switch (valorFiltro) {
      case 1: // De 0 a 10
        return experienciaArbitro >= 1 && experienciaArbitro <= 10;
      case 2: // De 11 a 25
        return experienciaArbitro >= 11 && experienciaArbitro <= 25;
      case 3: // Más de 25
        return experienciaArbitro > 25;
      default: // N/A o 0, no aplica filtro
        return true; // No filtra por este campo
    }
  }



  initializeForm(): void {
    // initialize forms       
    this.basicWizardForm = this.fb.group({
      datos: this.fb.group({
        sectores: [[]],
        nacionalidades: [[]],
        sistemasJuridicos: [[]],
        exp_internacional_ciam_presidente: 0,
        exp_internacional_otra_presidente: 0,
        exp_internacional_adhoc_presidente: 0,
        exp_nacional_institucional_presidente: 0,
        exp_nacional_adhoc_presidente: 0,
        exp_internacional_ciam_arbitro_unico: 0,
        exp_internacional_otra_arbitro_unico: 0,
        exp_internacional_adhoc_arbitro_unico: 0,
        exp_nacional_institucional_arbitro_unico: 0,
        exp_nacional_adhoc_arbitro_unico: 0,
        exp_internacional_ciam_coarbitro: 0,
        exp_internacional_otra_coarbitro: 0,
        exp_internacional_adhoc_coarbitro: 0,
        exp_nacional_institucional_coarbitro: 0,
        exp_nacional_adhoc_coarbitro: 0,
        exp_internacional_ciam_letrado: 0,
        exp_internacional_otra_letrado: 0,
        exp_internacional_adhoc_letrado: 0,
        exp_nacional_institucional_letrado: 0,
        exp_nacional_adhoc_letrado: 0,
        exp_internacional_ciam_secretario: 0,
        exp_internacional_otra_secretario: 0,
        exp_internacional_adhoc_secretario: 0,
        exp_nacional_institucional_secretario: 0,
        exp_nacional_adhoc_secretario: 0,
        exp_internacional_ciam_arbitro_emergencia: 0,
        exp_internacional_otra_arbitro_emergencia: 0,
        exp_internacional_adhoc_arbitro_emergencia: 0,
        exp_nacional_institucional_arbitro_emergencia: 0,
        exp_nacional_adhoc_arbitro_emergencia: 0,
        invertirNacionalidades: false,
        soloCompletados: false,
        es_arbitro: true,
        es_representante: false
      })
    })
  }

  /**
   * initialize advanced table columns
   */
  initTableCofig(): void {
    let currentLanguage: string = getCurrentLanguage()
    const currentTranslations = arbitroTranslations[currentLanguage].TABLE;
    this.columns = [
      {
        name: 'nombre',
        label: currentTranslations.NAME,
        formatter: (record: Arbitro) => record.nombre,
        width: 345,
      },
      {
        name: 'apellidos',
        label: currentTranslations.LAST_NAME,
        formatter: (record: Arbitro) => record.apellidos,
        width: 460,
      },
      {
        name: 'es_arbitro',
        label: currentTranslations.ES_ARBITRO,
        formatter: (record: Arbitro) => record.es_arbitro,
        width: 50,
        sort: false
      },
      {
        name: 'es_representante',
        label: currentTranslations.ES_REPRESENTANTE,
        formatter: (record: Arbitro) => record.es_representante,
        width: 50,
        sort: false
      },
      {
        name: 'accionesArbitros',
        label: currentTranslations.ACTIONS,
        formatter: (record: Arbitro) => null, // No necesito enviar nada porque advanced table ya trata la columna tipo acciones
        //formatter: (record: Arbitro) => "<i class='fe-edit editClickable_" + record.id + "'></i><i class='fe-trash-2 deleteClickable_" + record.id + "'></i>",
        width: 200,
        sort: false
      }
    ];
  }


  // compares two cell values
  compare(v1: string | number, v2: string | number): any {
    return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
  }

  /**
   * Sort the table data
   * @param event column name, sort direction
   */
  onSort(event: SortEvent): void {
    if (event.direction === '') {
      //this.records = ARBITROS;
    } else {
      this.records = [...this.records].sort((a, b) => {
        const res = this.compare(a[event.column] as string | number, b[event.column] as string | number);
        return event.direction === 'asc' ? res : -res;
      });
    }
  }

  /**
  * Recibe un texto y lo normaliza a lowercase y quita tildes para poder hacer búsquuedas
  * @param text Texto a normalizar
  */
  normalizeText(text: string): string {

    return text.trim().toLocaleLowerCase()
      .normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // Normaliza letras con tilde
  }


  /**
  * Match table data with search input
  * @param row Table row
  * @param term Search the value
  */
  matches(row: Arbitro, term: string) {

    // Aplicar la lógica de búsqueda
    return this.normalizeText(row.nombre as string).includes(this.normalizeText(term))
      || this.normalizeText(row.apellidos as string).includes(this.normalizeText(term));
  }


  /**
   * Search Method
  */
  searchData(searchTerm: string): void {
    if (searchTerm === '') {
      this.records = this.allDatasearch;
    }
    else {
      let updatedData = this.allDatasearch;

      //  filter
      updatedData = updatedData.filter(record => this.matches(record, searchTerm));
      //console.log("updatedData ->",updatedData)
      this.records = updatedData;
    }

  }

  // Para volver a filtros
  volver() {
    this.submitted = false;
  }

  // -----------------------------------
  // Exportación a csv
  // -----------------------------------


  exportToXlsx(filename: string, rows: Arbitro[]) {
    const columnNames: { [key: string]: string } = {
      "nombre": "Nombre",
      "apellidos": "Apellidos",
      "email": "Email",
      "es_arbitro": "Árbitro",
      "es_representante": "Representante",
      "institucion": "Institución",
      "cargo": "Cargo",
      "profesion": "Profesión",
      "idiomas": "Idiomas",
      "nacionalidades": "Nacionalidades",
      "exp_internacional_ciam_presidente": "Experiencia Internacional CIIAM como Presidente",
      "exp_internacional_ciam_arbitro_unico": "Experiencia Internacional CIIAM como Árbitro Único",
      "exp_internacional_ciam_coarbitro": "Experiencia Internacional CIIAM como Co-árbitro",
      "exp_internacional_ciam_letrado": "Experiencia Internacional CIIAM como Letrado",
      "exp_internacional_ciam_secretario": "Experiencia Internacional CIIAM como Secretario",
      "exp_internacional_ciam_arbitro_emergencia": "Experiencia Internacional CIIAM como Árbitro de Emergencia",
      "exp_internacional_otra_presidente": "Experiencia Internacional Otra como Presidente",
      "exp_internacional_otra_arbitro_unico": "Experiencia Internacional Otra como Árbitro Único",
      "exp_internacional_otra_coarbitro": "Experiencia Internacional Otra como Co-árbitro",
      "exp_internacional_otra_letrado": "Experiencia Internacional Otra como Letrado",
      "exp_internacional_otra_secretario": "Experiencia Internacional Otra como Secretario",
      "exp_internacional_otra_arbitro_emergencia": "Experiencia Internacional Otra como Árbitro de Emergencia",
      "exp_internacional_adhoc_presidente": "Experiencia Internacional Ad Hoc como Presidente",
      "exp_internacional_adhoc_arbitro_unico": "Experiencia Internacional Ad Hoc como Árbitro Único",
      "exp_internacional_adhoc_coarbitro": "Experiencia Internacional Ad Hoc como Co-árbitro",
      "exp_internacional_adhoc_letrado": "Experiencia Internacional Ad Hoc como Letrado",
      "exp_internacional_adhoc_secretario": "Experiencia Internacional Ad Hoc como Secretario",
      "exp_internacional_adhoc_arbitro_emergencia": "Experiencia Internacional Ad Hoc como Árbitro de Emergencia",
      "exp_nacional_institucional_presidente": "Experiencia Nacional Institucional como Presidente",
      "exp_nacional_institucional_arbitro_unico": "Experiencia Nacional Institucional como Árbitro Único",
      "exp_nacional_institucional_coarbitro": "Experiencia Nacional Institucional como Co-árbitro",
      "exp_nacional_institucional_letrado": "Experiencia Nacional Institucional como Letrado",
      "exp_nacional_institucional_secretario": "Experiencia Nacional Institucional como Secretario",
      "exp_nacional_institucional_arbitro_emergencia": "Experiencia Nacional Institucional como Árbitro de Emergencia",
      "exp_nacional_adhoc_presidente": "Experiencia Nacional Ad Hoc como Presidente",
      "exp_nacional_adhoc_arbitro_unico": "Experiencia Nacional Ad Hoc como Árbitro Único",
      "exp_nacional_adhoc_coarbitro": "Experiencia Nacional Ad Hoc como Co-árbitro",
      "exp_nacional_adhoc_letrado": "Experiencia Nacional Ad Hoc como Letrado",
      "exp_nacional_adhoc_secretario": "Experiencia Nacional Ad Hoc como Secretario",
      "exp_nacional_adhoc_arbitro_emergencia": "Experiencia Nacional Ad Hoc como Árbitro de Emergencia",
      // Agrega cualquier otro mapeo de columnas necesario...
    };

    if (!rows || !rows.length) {
      return;
    }

    // Filtrar y preparar las filas según las columnas que deseamos exportar
    const dataToExport = rows.map(row => {
      const newRow: { [key: string]: any } = {};
      Object.keys(columnNames).forEach(key => {
        const newKey = columnNames[key];
        const value = row[key as keyof Arbitro];
        if (key === 'nacionalidades' && Array.isArray(value)) {
          newRow[newKey] = convertNacionalidadesToLabels(value, this.nacionalidades); // Transforma los códigos en etiquetas
        } else if (key === 'idiomas' && Array.isArray(value)) {
          newRow[newKey] = convertIdiomasToLabels(value, this.idiomas); // Transforma los códigos en etiquetas
        } else if (Array.isArray(value)) { // Para todos los arrays excepto nacionalidades
          newRow[newKey] = value.join(', '); // Une los idiomas con coma
        } else {
          newRow[newKey] = value; // Mantiene el valor original para las demás columnas
        }
      });
      return newRow;
    });

    // Convertir los datos preparados a una hoja de cálculo
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport, {
      header: Object.values(columnNames), // Usamos solo los nombres de las columnas definidas en columnNames
      skipHeader: false // Incluye el encabezado
    });

    // Crear un nuevo libro y añadir la hoja de cálculo
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Datos');

    // Opciones para la escritura del archivo
    const writeOptions: XLSX.WritingOptions = {
      bookType: 'xlsx',
      type: 'binary'
    };

    // Escribe el libro a un archivo binario
    const excelBuffer: any = XLSX.write(workbook, writeOptions);

    // Convertir el buffer a Blob para descarga
    const data: Blob = new Blob([this.s2ab(excelBuffer)], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });

    // Tratamiento para la descarga del archivo
    if ((navigator as any).msSaveBlob) {
      (navigator as any).msSaveBlob(data, filename);
    } else {
      const link: HTMLAnchorElement = document.createElement('a');
      const url: string = URL.createObjectURL(data);
      link.href = url;
      link.download = filename + '.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
  }


  // Función auxiliar para convertir string a ArrayBuffer
  private s2ab(s: string): ArrayBuffer {
    const buffer: ArrayBuffer = new ArrayBuffer(s.length);
    const view: Uint8Array = new Uint8Array(buffer);
    for (let i = 0; i < s.length; i++) {
      view[i] = s.charCodeAt(i) & 0xFF;
    }
    return buffer;
  }

  updateOpenPanels() {
    this.openIds = []; // Limpia el array actual para no acumular IDs antiguos.

    const formData = this.basicWizardForm.value.datos;

    // Experiencias internacionales CIAM
    if (formData.exp_internacional_ciam_presidente > 0 ||
      formData.exp_internacional_ciam_arbitro_unico > 0 ||
      formData.exp_internacional_ciam_coarbitro > 0 ||
      formData.exp_internacional_ciam_letrado > 0 ||
      formData.exp_internacional_ciam_secretario > 0 ||
      formData.exp_internacional_ciam_arbitro_emergencia > 0) {
      this.openIds.push('customAccordion1');
    }

    // Experiencias internacionales Otra
    if (formData.exp_internacional_otra_presidente > 0 ||
      formData.exp_internacional_otra_arbitro_unico > 0 ||
      formData.exp_internacional_otra_coarbitro > 0 ||
      formData.exp_internacional_otra_letrado > 0 ||
      formData.exp_internacional_otra_secretario > 0 ||
      formData.exp_internacional_otra_arbitro_emergencia > 0) {
      this.openIds.push('customAccordion2');
    }

    // Experiencias internacionales Ad Hoc
    if (formData.exp_internacional_adhoc_presidente > 0 ||
      formData.exp_internacional_adhoc_arbitro_unico > 0 ||
      formData.exp_internacional_adhoc_coarbitro > 0 ||
      formData.exp_internacional_adhoc_letrado > 0 ||
      formData.exp_internacional_adhoc_secretario > 0 ||
      formData.exp_internacional_adhoc_arbitro_emergencia > 0) {
      this.openIds.push('customAccordion3');
    }

    // Experiencias nacionales Institucional
    if (formData.exp_nacional_institucional_presidente > 0 ||
      formData.exp_nacional_institucional_arbitro_unico > 0 ||
      formData.exp_nacional_institucional_coarbitro > 0 ||
      formData.exp_nacional_institucional_letrado > 0 ||
      formData.exp_nacional_institucional_secretario > 0 ||
      formData.exp_nacional_institucional_arbitro_emergencia > 0) {
      this.openIds.push('customAccordion4');
    }

    // Experiencias nacionales Ad Hoc
    if (formData.exp_nacional_adhoc_presidente > 0 ||
      formData.exp_nacional_adhoc_arbitro_unico > 0 ||
      formData.exp_nacional_adhoc_coarbitro > 0 ||
      formData.exp_nacional_adhoc_letrado > 0 ||
      formData.exp_nacional_adhoc_secretario > 0 ||
      formData.exp_nacional_adhoc_arbitro_emergencia > 0) {
      this.openIds.push('customAccordion5');
    }

  }





}
